import { render, staticRenderFns } from "./TravelDetailItem.vue?vue&type=template&id=1fa3bb42&"
import script from "./TravelDetailItem.vue?vue&type=script&lang=js&"
export * from "./TravelDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports